module.exports = __webpack_public_path__ + "static/media/home.de2c30dc.png";